define('uikit/collections/segment.list',['require','exports','module','underscore','marionette','../mixins/component.mixin','./list'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var List           = require('./list');

  var Segment = List.Item.extend({

    className: 'ui segment',

    options: _.extend({}, List.Item.prototype.options, {
      attached: false,
      selectable: false,
      active: false
    }),

    forceUpdate: _.extend({}, List.Item.prototype.forceUpdate, {
      selectable: true
    }),

    events: {
      'keydown' : function(ev) {
        if (ev.keyCode == 13) {
          this.triggerMethod('press');
        }
      }
    },

    triggers: {
      'click': {
        event: 'press',
        stopPropagation: false,
        preventDefault: false
      }
    },

    updateAttributes: function() {
      List.Item.prototype.updateAttributes.apply(this, arguments);

      this
          .addClass('attached', this.getBoolOption('attached'))
          .addClass('selectable', this.getBoolOption('selectable'))
          .addClass('active', this.getBoolOption('active'))
    }

  });

  var SegmentList = Mn.CollectionView.extend(ComponentMixin).extend({

    options: {
      selected: null,
      selectedIndex: 0,
      selectable: false
    },

    childView: Segment,

    onBeforeAddChild: function(child) {
      child._parent = this;
    },

    childViewOptions: function() {
      return {
        selectable: this.selectable,
        attached: true
      }
    },

    onChangeSelectable: function() {
      this.children.each(function(child) {
        child.selectable = this.selectable;
      }, this)
    },

    _initialEvents: function() {
      Mn.CollectionView.prototype._initialEvents.apply(this, arguments);
      this.listenTo(this.collection, 'add remove reset sort', _.debounce(this.updateChildAttachment));
      this.listenTo(this.collection, 'add remove reset sort', _.debounce(this._updateSelected));
      this.on('change:selected', this._updateActiveChild, this);
      this.on('change:selectedIndex', this._updateSelected, this);
      if (this.children.length > 0) {
        this._updateSelected();
        this.updateChildAttachment();
      }
    },

    onChildviewPress: function(child) {
      if (!this.selectable) { return };
      this.selected = child;
    },

    _updateSelected: function() {
      if (!this.selectable) { return; }

      if (this.children.length > this.selectedIndex) {
        this.selected = this.children.findByIndex(this.selectedIndex);
      }
    },

    _updateActiveChild: function(self, child, previous) {
      if (!this.selectable) { return; }

      if (child) {
        child.active = true;
      }

      if (previous) {
        previous.active = false;
      }

      var children = this.children.toArray();
      this.selectedIndex = _.indexOf(children, child);
    },

    updateChildAttachment: function() {
      var first = this.children.first(),
          last  = this.children.last();

      if (this._previousFirst) {
        this._previousFirst.$el.removeClass('top');
      }

      if (this._previousLast) {
        this._previousLast.$el.removeClass('bottom');
      }

      if (first) {
        first.$el.removeClass('attached').addClass('top attached');
        last.$el.removeClass('attached').addClass('bottom attached');
      }

      this._previousFirst = first;
      this._previousLast = last;
    }

  });

  SegmentList.Segment = Segment;

  module.exports = SegmentList;
});
